<template>
  <v-container fluid fill-height pa-0>
    <v-layout column fill-height ma-0 pa-0>
      <v-layout fill-height column ma-0 pt-0 >
     
        <scroll-area>

          <template slot="header">

            <v-toolbar class="active" :height="44" flat dark>
              <v-toolbar-title>
                <span class="body-2 text-uppercase blacktext--text">{{ $t('backup management') }}</span>
              </v-toolbar-title>

              <v-layout fill-height justify-end align-center>

                <v-tooltip v-if="edit" dark color="secondary" bottom>
                  <v-btn icon flat slot="activator" 
                    :data-testid="$options.name + '__btn__' + 'submit'"
                    @click="() => submit()"
                    >
                    <svg-icon
                      :color="'blacktext'"
                      :name="'done'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('save') }}</span>
                </v-tooltip>

                <v-tooltip v-if="!edit" dark color="secondary" bottom>
                  <v-btn icon flat slot="activator" 
                   :data-testid="$options.name + '__btn__' + 'edit'"
                    @click="() => {edit = !edit}"
                    >
                    <svg-icon
                      :color="'blacktext'"
                      :name="'edit'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('edit') }}</span>
                </v-tooltip>

                <v-tooltip v-if="edit" dark color="secondary" bottom>
                  <v-btn icon flat slot="activator"  
                    :data-testid="$options.name + '__btn__' + 'cancel'"
                    @click="() => cancelEdit()"
                    >
                    <svg-icon
                      :color="'blacktext'"
                      :name="'close'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('cancel') }}</span>
                </v-tooltip>

              </v-layout>

            </v-toolbar>

          </template>
          
          <template slot="body">

            <v-layout fill-height justify-start ma-0 pa-1 >
              <v-flex xs6 px-0>
                <v-layout column fill-height justify-start ma-0>

                  <v-toolbar 
                    :height="44"
                    class="active" 
                    flat
                    prominent
                    @click.stop=""
                  >
                    <v-toolbar-title>
                      <span class="body-2 uppercase blacktext--text"> {{$t('inventory')}} </span>
                    </v-toolbar-title>

                  </v-toolbar>

                  <v-layout shrink column>
                    <v-layout shrink justify-start>
                      <v-flex xs3 px-0>
                        <v-btn dark block small color="success"
                        :data-testid="$options.name + '__btn__' + 'createCopy_cmdb'"
                        @click="() => createCopy('cmdb')" 
                        >{{$t('create copy')}}</v-btn>
                      </v-flex>

                      <v-flex xs3 v-if="!selectedCMDBDump"  px-1>
                        <v-btn dark block small @click="" color="success" slot="activator" :data-testid="$options.name + '__btn__' + 'upload_cmdb'">
                          <span>{{$t('upload copy')}}</span>
                          <input  multiple accept 
                            v-if="!clear" 
                            ref="file-input" 
                            class="button-file-upload__input" 
                            type="file" 
                            title=" "
                            :data-testid="$options.name + '__input__' + 'file-input_cmdb'"
                            @change="(e) => onFileAdd(e, 'cmdb')" >
                        </v-btn>
                      </v-flex>

                      <v-flex xs3 v-if="selectedCMDBDump" px-2>
                        <v-btn block small color="accent"
                          :data-testid="$options.name + '__btn__' + 'download_cmdb'"
                          @click="() => downloadCopy('cmdb')" 
                          >{{$t('download copy')}}</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout fill-height justify-start>
                      <v-flex xs3 pa-0>
                        <v-btn block small :disabled="!selectedCMDBDump" color="success"
                        :data-testid="$options.name + '__btn__' + 'restore_cmdb'"
                        @click="() => restoreCopy('cmdb')" >{{$t('restore copy')}}</v-btn>
                      </v-flex>
                      
                      <v-flex xs9 px-2>
                        <v-select
                          :data-testid="$options.name + '__select__' + 'select_dump_cmdb'"
                          v-model="selectedCMDBDump"
                          :items="getDumps.cmdb"
                          :label="$t('select dump')"
                          :item-text="'name'"
                          :item-value="'name'"
                          clearable
                          hide-details
                          solo
                          flat
                          class="white"
                          background-color="white"
                          return-object
                        >
                        </v-select>
                      </v-flex>

                    </v-layout>
                  </v-layout>

                  <v-toolbar 
                    :height="44"
                    class="active" 
                    flat
                    prominent
                    @click.stop=""
                  >
                    <v-toolbar-title>
                      <span class="body-2 uppercase blacktext--text"> {{$t('scheduler parameters')}}  </span>
                    </v-toolbar-title>

                  </v-toolbar>

                  <v-layout shrink justify-start pt-1>

                      <v-flex xs9 pa-0 align-content-center>
                        <v-text-field
                          :value="$t('backup create time')"
                          light
                          outline
                          readonly
                          disabled
                          class="backgrey"
                          hide-details                    
                          :rows="1"
                          color="white"
                        >
                        </v-text-field>
                      </v-flex>

                      <v-flex xs3>
                        <v-text-field
                          :data-testid="$options.name + '__text-field__' + 'auto_backup_cmdb'"
                          v-model="model.obj.auto_backup"
                          validate-on-blur
                          light
                          outline
                          :readonly="!edit"
                          class="white"
                          hide-details
                          :rows="1"
                          color="accent"
                        >                     
                        </v-text-field>
                        
                      </v-flex>

                  </v-layout>

                  <v-layout shrink justify-start pt-1>

                      <v-flex xs9 align-content-center pa-0>
                        <v-text-field
                          :value="$t('storage depth')"
                          light
                          outline
                          readonly
                          disabled
                          class="backgrey"
                          hide-details                    
                          :rows="1"
                          color="white"
                        >
                        </v-text-field>
                      </v-flex>

                      <v-flex xs3>
                        <v-text-field
                          :type="'number'"
                          :data-testid="$options.name + '__text-field__' + 'backup_limitation_cmdb'"
                          v-model="model.obj.backup_limitation"
                          :suffix="model.fields.backup_limitation?.unit"
                          validate-on-blur
                          light
                          outline
                          :readonly="!edit"
                          :class="'white'"
                          hide-details
                          :rows="1"
                        >
                        </v-text-field>
                        
                      </v-flex>

                  </v-layout>

                </v-layout>
              </v-flex>
             
              <v-flex xs6 px-0>
                <v-layout column fill-height justify-start ma-0 pl-1>

                  <v-toolbar 
                    :height="44"
                    class="active" 
                    flat
                    prominent
                    @click.stop=""
                  >
                    <v-toolbar-title>
                      <span class="body-2 uppercase blacktext--text"> {{$t('streaming data')}} </span>
                      <span v-if="noStreamData" class="body-2 uppercase blacktext--text"> {{$t('(нет данных)')}} </span>
                    </v-toolbar-title>

                  </v-toolbar>

                  <v-layout shrink column>
                    <v-layout shrink justify-start>
                      <v-flex xs3 pa-0>
                        <v-btn dark block small color="success"
                        :data-testid="$options.name + '__btn__' + 'createCopy_streaming_data'"
                        @click="() => createCopy('stream')" >{{$t('create copy')}}</v-btn>
                      </v-flex>

                      <v-flex xs3 v-if="!selectedStreamDump"  px-1>
                        <v-btn dark block small @click="" color="success" slot="activator" :data-testid="$options.name + '__btn__' + 'upload_streaming_data'">
                          <span>{{$t('upload copy')}}</span>
                          <input class="button-file-upload__input" multiple accept 
                            v-if="!clear" 
                            ref="file-input" 
                            type="file" 
                            title=" "
                            :data-testid="$options.name + '__input__' + 'file-input_streaming_data'"
                            @change="(e) => onFileAdd(e, 'stream')" >
                        </v-btn>
                      </v-flex>

                      <v-flex v-if="selectedStreamDump" xs3 px-2>
                        <v-btn block small color="accent"
                        :data-testid="$options.name + '__btn__' + 'download_streaming_data'"
                        @click="() => downloadCopy('stream')">{{$t('download copy')}}</v-btn>
                      </v-flex>

                    </v-layout>
                    <v-layout fill-height justify-start>
                      <v-flex xs3 pa-0>
                        <v-btn block small color="success"
                        :disabled="!selectedStreamDump" 
                        :data-testid="$options.name + '__btn__' + 'restore_streaming_data'"
                        @click="() => restoreCopy('stream')">{{$t('restore copy')}}</v-btn>
                      </v-flex>

                      <v-flex px-2>
                        <v-select
                          :data-testid="$options.name + '__select__' + 'select_dump_streaming_data'"
                          v-model="selectedStreamDump"
                          :items="getDumps.stream"
                          :label="$t('select dump')"
                          :item-text="'backUpName'"
                          :item-value="'backUpName'"
                          clearable
                          hide-details
                          solo
                          flat
                          class="white"
                          background-color="white"
                          return-object
                        >
                        </v-select>
                      </v-flex>

                    </v-layout>
                  </v-layout>

                  <v-layout shrink column justify-start ma-0 pb-1>
                    <v-layout shrink justify-start px-1>
                      <span class="body-2 text-uppercase">{{$t('audit')}}</span>
                    </v-layout>
                    
                    <v-layout shrink justify-start pa-0>
                      <v-layout fill-height justify-start>

                        <v-flex xs9 align-content-center pa-0>
                          <v-text-field
                            :value="$t('data storage period')"
                            light
                            outline
                            readonly
                            disabled
                            class="backgrey"
                            hide-details                    
                            :rows="1"
                            color="white"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex xs1>
                          <v-text-field
                            :data-testid="$options.name + '__text-field__' + 'data_limitation_default_audit'"
                            :type="'number'"
                            v-model="streamData.settingsTtlFlows.clearNum"
                            validate-on-blur
                            light
                            outline
                            :readonly="!edit"
                            :disabled="!edit"
                            class="white"
                            hide-details
                            :rows="1"
                            color="accent"
                          >                     
                          </v-text-field>
                          
                        </v-flex>

                        <v-flex xs2>

                          <v-select
                            :data-testid="$options.name + '__select__' + 'interval_limitation_default_audit'"
                            v-model="streamData.settingsTtlFlows.clearInterval"
                            light
                            :items="getEnums.timebackup"
                            :item-text="'value'"
                            :item-value="'id'"
                            :readonly="!edit"
                            :disabled="!edit"
                            outline
                            hide-details
                            class="white"
                          >
                            <template v-slot:item="{ item, index }">
                                <span>{{ $t(item.value) }}</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <span>{{ $t(item.value) }}</span>
                            </template>
                          </v-select>
                          
                        </v-flex>

                      </v-layout>
                    </v-layout>
                  </v-layout>

                  <v-layout shrink column justify-start ma-0 pb-1>
                    <v-layout shrink justify-start px-1>
                      <span class="body-2 text-uppercase">{{$t('logs')}}</span>
                    </v-layout>
                    
                    <v-layout shrink justify-start pa-0>
                      <v-layout fill-height justify-start>

                        <v-flex xs9 align-content-center pa-0>
                          <v-text-field
                            :value="$t('data storage period')"
                            light
                            outline
                            readonly
                            disabled
                            class="backgrey"
                            hide-details                    
                            :rows="1"
                            color="white"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex xs1>
                          <v-text-field
                            :data-testid="$options.name + '__text-field__' + 'data_limitation_logs_logs'"
                            :type="'number'"
                            v-model="streamData.settingsTtlLogs.clearNum"
                            validate-on-blur
                            light
                            outline
                            :readonly="!edit"
                            :disabled="!edit"
                            class="white"
                            hide-details
                            :rows="1"
                            color="accent"
                          >                     
                          </v-text-field>                      
                        </v-flex>

                        <v-flex xs2>
                          <v-select
                            :data-testid="$options.name + '__select__' + 'interval_limitation_logs_logs'"
                            v-model="streamData.settingsTtlLogs.clearInterval"
                            light
                            :items="getEnums.timebackup"
                            :item-text="'value'"
                            :item-value="'id'"
                            :readonly="!edit"
                            :disabled="!edit"
                            outline
                            hide-details
                            class="white"
                          >
                            <template v-slot:item="{ item, index }">
                                <span>{{ $t(item.value) }}</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <span>{{ $t(item.value) }}</span>
                            </template>
                          </v-select>                        
                        </v-flex>

                      </v-layout>
                    </v-layout>
                  </v-layout>

                  <v-layout shrink column justify-start ma-0 pb-1>
                    <v-layout shrink justify-start px-1>
                      <span class="body-2 text-uppercase">{{$t('metrics')}}</span>
                    </v-layout>
                    
                    <v-layout shrink justify-start pa-0>
                      <v-layout fill-height justify-start>

                        <v-flex xs9 align-content-center pa-0>
                          <v-text-field
                            :value="$t('data storage period')"
                            light
                            outline
                            readonly
                            disabled
                            class="backgrey"
                            hide-details                    
                            :rows="1"
                            color="white"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex xs1>
                          <v-text-field
                            :data-testid="$options.name + '__text-field__' + 'data_limitation_metrics_metrics'"
                            :type="'number'"
                            v-model="streamData.settingsTtlMetrics.clearNum"
                            validate-on-blur
                            light
                            outline
                            :readonly="!edit"
                            :disabled="!edit"
                            class="white"
                            hide-details
                            :rows="1"
                            color="accent"
                          >                     
                          </v-text-field>                      
                        </v-flex>

                        <v-flex xs2>
                          <v-select
                            :data-testid="$options.name + '__select__' + 'interval_limitation_metrics_metrics'"
                            v-model="streamData.settingsTtlMetrics.clearInterval"
                            light
                            :items="getEnums.timebackup"
                            :item-text="'value'"
                            :item-value="'id'"
                            :readonly="!edit"
                            :disabled="!edit"
                            outline
                            hide-details
                            class="white"
                          >
                            <template v-slot:item="{ item, index }">
                                <span>{{ $t(item.value) }}</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <span>{{ $t(item.value) }}</span>
                            </template>
                          </v-select>                          
                        </v-flex>

                      </v-layout>
                    </v-layout>
                  </v-layout>

                  <v-layout shrink column justify-start ma-0 pb-1>
                    <v-layout shrink justify-start px-1>
                      <span class="body-2 text-uppercase">{{$t('system log')}}</span>
                    </v-layout>
                    
                    <v-layout shrink justify-start pa-0>
                      <v-layout fill-height justify-start>

                        <v-flex xs9 align-content-center pa-0>
                          <v-text-field
                            :value="$t('data storage period')"
                            light
                            outline
                            readonly
                            disabled
                            class="backgrey"
                            hide-details                    
                            :rows="1"
                            color="white"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex xs1>
                          <v-text-field
                            :data-testid="$options.name + '__text-field__' + 'data_limitation_syslog_syslog'"
                            :type="'number'"
                            v-model="streamData.settingsTtlSyslogs.clearNum"
                            validate-on-blur
                            light
                            outline
                            :readonly="!edit"
                            :disabled="!edit"
                            class="white"
                            hide-details
                            :rows="1"
                            color="accent"
                          >                     
                          </v-text-field>                          
                        </v-flex>

                        <v-flex xs2>
                          <v-select
                            :data-testid="$options.name + '__select__' + 'interval_limitation_syslog_syslog'"
                            v-model="streamData.settingsTtlSyslogs.clearInterval"
                            light
                            :items="getEnums.timebackup"
                            :item-text="'value'"
                            :item-value="'id'"
                            :readonly="!edit"
                            :disabled="!edit"
                            outline
                            hide-details
                            class="white"
                          >
                            <template v-slot:item="{ item, index }">
                                <span>{{ $t(item.value) }}</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <span>{{ $t(item.value) }}</span>
                            </template>
                          </v-select>                          
                        </v-flex>

                      </v-layout>
                    </v-layout>
                  </v-layout>

                  <v-layout shrink column justify-start ma-0 pb-1>
                    <v-layout shrink justify-start px-1>
                      <span class="body-2 text-uppercase">{{$t('tasks')}}</span>
                    </v-layout>
                    
                    <v-layout shrink justify-start pa-0>
                      <v-layout fill-height justify-start>

                        <v-flex xs9 align-content-center pa-0>
                          <v-text-field
                            :value="$t('data storage period')"
                            light
                            outline
                            readonly
                            disabled
                            class="backgrey"
                            hide-details                    
                            :rows="1"
                            color="white"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex xs1>
                          <v-text-field
                            :data-testid="$options.name + '__text-field__' + 'data_limitation_tasks_tasks'"
                            :type="'number'"
                            v-model="streamData.settingsTtlTasks.clearNum"
                            validate-on-blur
                            light
                            outline
                            :readonly="!edit"
                            :disabled="!edit"
                            class="white"
                            hide-details
                            :rows="1"
                            color="accent"
                          >                     
                          </v-text-field>                          
                        </v-flex>

                        <v-flex xs2>
                          <v-select
                            :data-testid="$options.name + '__select__' + 'interval_limitation_tasks_tasks'"
                            v-model="streamData.settingsTtlTasks.clearInterval"
                            light
                            :items="getEnums.timebackup"
                            :item-text="'value'"
                            :item-value="'id'"
                            :readonly="!edit"
                            :disabled="!edit"
                            outline
                            hide-details
                            class="white"
                          >
                            <template v-slot:item="{ item, index }">
                                <span>{{ $t(item.value) }}</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <span>{{ $t(item.value) }}</span>
                            </template>
                          </v-select>                         
                        </v-flex>

                      </v-layout>
                    </v-layout>
                  </v-layout>

                  <v-layout column shrink justify-start mt-1 pa-0>

                    <v-toolbar 
                      :height="44"
                      class="active" 
                      flat
                      prominent
                      @click.stop=""
                    >
                      <v-toolbar-title>
                        <span class="body-2 uppercase blacktext--text"> {{$t('scheduler parameters')}}  </span>
                      </v-toolbar-title>

                    </v-toolbar>

                    <v-layout fill-height justify-start pt-1>

                      <v-flex xs9 pa-0 align-content-center>
                        <v-text-field
                            :value="$t('backup create time')"
                            light
                            outline
                            readonly
                            disabled
                            class="backgrey"
                            hide-details                    
                            :rows="1"
                            color="white"
                          >
                          </v-text-field>
                      </v-flex>

                      <v-flex xs3>
                        <v-text-field
                          :data-testid="$options.name + '__text-field__' + 'auto_backup_streaming_data'"
                          v-model="streamData.backUp.autoBackup"
                          validate-on-blur
                          light
                          outline
                          :readonly="!edit"
                          class="white"
                          hide-details
                          :rows="1"
                          color="accent"
                        >                     
                        </v-text-field>
                        
                      </v-flex>

                    </v-layout>
                  </v-layout>

                </v-layout>
              </v-flex>

            </v-layout>

          </template>

        </scroll-area>

      </v-layout>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { $_localhost } from '@/nms/plugins/bridge.js'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface DumpItem {
  id?: string
  name?: string
  backUpName?: string
  [key: string]: any
}

interface DumpsData {
  cmdb: DumpItem[]
  stream: DumpItem[]
}

interface ModelData {
  obj: Record<string, any>
  fields: Record<string, any>
}

interface StreamData {
  [key: string]: any
}

interface EnumData {
  [key: string]: any[]
}

interface CurrentFilesState {
  files: CustomFile[]
  update: string[]
}

interface CustomFile extends File {
  data?: {
    hash?: string
    description?: string
    callback?: {
      progress?: (item: any, progress: any) => void
      success?: (item: any, response: any) => void
      warning?: (item: any, message: string) => void
      error?: (item: any, message: string) => void
    }
  }
  [key: string]: any
}

interface UploadProgress {
  loaded: number
  total?: number
  [key: string]: any
}

export default Vue.extend({
  name: 'BACKUP_PANEL',

  components: {
    scrollArea,
    scrollTable,
    svgIcon,
  },

  props: {},

  data(): {
    show: boolean
    clear: boolean
    cmdbBackupFilesParentId: string
    selectedCMDBDump: DumpItem | null
    selectedStreamDump: DumpItem | null
    dumps: DumpsData
    meta: any | null
    data: any | null
    model: ModelData
    streamData: StreamData | null
    noStreamData: boolean
    enums: EnumData
    edit: boolean
    smeta: any | null
    sdata: any | null
    smodel: ModelData
    current: CurrentFilesState
  } {
    return {
      show: false,
      clear: false,
      cmdbBackupFilesParentId: '',
      selectedCMDBDump: null,
      selectedStreamDump: null,
      dumps: {
        cmdb: [],
        stream: [],
      },
      meta: null,
      data: null,
      model: {
        obj: {},
        fields: {}
      },
      streamData: {
        settingsTtlFlows: {
          clearNum: null,
          clearInterval: null,
        },
        settingsTtlLogs: {
          clearNum: null,
          clearInterval: null,
        },
        settingsTtlMetrics: {
          clearNum: null,
          clearInterval: null,
        },
        settingsTtlSyslogs: {
          clearNum: null,
          clearInterval: null,
        },
        settingsTtlTasks: {
          clearNum: null,
          clearInterval: null,
        },
        backUp: {
          autoBackup: null,
        },
      },
      noStreamData: false,
      enums: {},
      edit: false,
      smeta: null,
      sdata: null,
      smodel: {
        obj: {},
        fields: {}
      },
      current: {
        files: [],
        update: []
      },
    }
  },

  computed: {
    getData(): any | null {
      return this.data
    },
    getSData(): any | null {
      return this.sdata
    },
    getStreamData(): any | null {
      return this.streamData
    },
    getObj(): Record<string, any> {
      return this.model.obj
    },
    getFields(): Record<string, any> {
      return this.model.fields
    },
    getItems(): Record<string, any> | undefined {
      return this.smodel.items
    },
    getEnums(): EnumData {
      return this.enums
    },
    getDumps(): DumpsData {
      return this.dumps
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      await this.loadMeta()
      await this.loadDumps()
      this.show = true
    },

    async loadDumps(): Promise<void> {
      try {
        const reqCmdb = await this.$bridge.customQuery('scripter', 'filemanager/files/Lw/children', { data: { orderBy: 'name', orderDirection: 'ASC' } }, 'GET')
        
        if (reqCmdb?.items) {
          const pgBackUpFiles = reqCmdb.items.find((el: any) => el.name === 'pgbackup')
          if (pgBackUpFiles) {
            this.cmdbBackupFilesParentId = pgBackUpFiles.id
            const d = await this.$bridge.customQuery('scripter', `filemanager/files/${pgBackUpFiles.id}/children`, { data: { orderBy: 'name', orderDirection: 'ASC' } }, 'GET')
            if (d?.items) {
              this.dumps.cmdb = d.items
              console.log(this.$options.name, 'loadDumps', 'pgBackUpFiles', pgBackUpFiles)
            }
          }
        }

        const reqStream = await this.$bridge.customQuery('core', 'monitoring/listBackUp', {}, 'get') as DumpItem[]
        if (reqStream?.length) {
          this.dumps.stream = reqStream
        }

        console.log(this.$options.name, 'loadDumps', 'reqStream', reqStream)
        console.log(this.$options.name, 'loadDumps', 'this.dumps', this.dumps)
      } catch (error) {
        console.error(this.$options.name, 'loadDumps smth wrong', error)
      }
    },

    async loadStreamData(): Promise<void> {
      try {
        this.noStreamData = false
        const paths = [
          'tree:/config/service/settingsTtlLogs',
          'tree:/config/service/settingsTtlMetrics',
          'tree:/config/service/settingsTtlFlows',
          'tree:/config/service/settingsTtlSyslogs',
          'tree:/config/service/settingsTtlTasks',
          'tree:/config/service/backUp'
        ]

        const requests = paths.map(path =>
          this.$bridge.customQuery('core', 'net-storage/getByPath', { path }, 'get')
        )

        const results = await Promise.all(requests)
        if (results.length) {
          this.streamData = {}
          results.forEach((res: any) => {
            if (res?.name) {
              this.streamData![res.name] = res.data || res
            }
          })
        }
        else {
          this.noStreamData = true
        }
      } catch (error) {
        this.noStreamData = true
        console.error(this.$options.name, 'loadStreamData smth wrong', error)
      }
    },

    async loadMeta(): Promise<void> {
      try {
        this.meta = await this.$loadMeta('backupcmdb')
        const objects = await this.$bridge.getObjectsByClass('backupcmdb')
        this.data = objects?.[0] || null
        this.model = await this.$prepareMeta(this.meta, this.$options.name)

        // const loadStreamData = async (): Promise<void> => {
        //   const paths = [
        //     'tree:/config/service/settingsTtlLogs',
        //     'tree:/config/service/settingsTtlMetrics',
        //     'tree:/config/service/settingsTtlFlows',
        //     'tree:/config/service/settingsTtlSyslogs',
        //     'tree:/config/service/settingsTtlTasks',
        //     'tree:/config/service/backUp'
        //   ]

        //   const requests = paths.map(path =>
        //     this.$bridge.customQuery('core', 'net-storage/getByPath', { path }, 'get')
        //   )

        //   const results = await Promise.all(requests)
        //   if (results.length) {
        //     this.streamData = {}
        //     results.forEach((res: any) => {
        //       if (res?.name) {
        //         this.streamData![res.name] = res.data || res
        //       }
        //     })
        //   }
        // }

        this.loadStreamData()
        // console.log(this.$options.name, 'loadMeta', 'streamData_', streamData_)

        this.smeta = await this.$loadMeta('backupstreamingdata')
        const sObjects = await this.$bridge.getObjectsByClass('backupstreamingdata')
        this.sdata = sObjects?.[0] || null
        this.smodel = await this.$prepareMeta(this.smeta, this.$options.name)

        this.enums['timebackup'] = await this.$bridge.getEnum('timebackup')
        this.prepareData()
      } catch (error) {
        console.error(this.$options.name, 'loadMeta smth wrong', error)
      }
    },

    async prepareData(): Promise<void> {
      try {
        if (this.getData) {
          const model = await this.$prepareData(this.model, this.getData, this.meta)
          if (model) {
            console.log(this.$options.name, 'prepareData', 'model', model)
            this.model = model
          }
        }
        if (this.getData?.$id) {
          this.$set(this.model.fields, '$id', this.getData.$id)
        }

        if (this.getSData) {
          const smodel = await this.$prepareData(this.smodel, this.getSData, this.smeta)
          if (smodel) {
            console.log(this.$options.name, 'prepareData', 'smodel', smodel)
            this.smodel = smodel
          }
        }
        if (this.getSData?.$id) {
          this.$set(this.smodel.fields, '$id', this.getSData.$id)
        }
      } catch (error) {
        this.setLoader('prepareData', false)
        console.error('CATCH', this.$options.name, 'prepareData', 'SMTH WRONG', error)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    cancelEdit(): void {
      this.edit = false
      this.setup()
    },

    async mapFiles(): Promise<CustomFile[]> {
      const mFiles: CustomFile[] = []

      this.current.files.forEach(item => {
        if (!item.data) {
          item.data = {}
        }
        item.data.callback = {
          progress: (fileItem: CustomFile, progress: UploadProgress) => {
            if (progress.loaded < 1000000) return

            const toast = this.$snotify.get('toast-' + fileItem.name)

            if (!toast) {
              this.$snotify.html(
                '<div class="fit"><span class="text-truncate block">' + fileItem.name + '</span></div>' +
                '<div class="caption fit"><span id="toast-progress-text-' + fileItem.name + '" class="text-truncate block">Файл загружен на <span id="toast-progress-value-' + fileItem.name + '">' + progress.loaded + '</span>%</span></div>' +
                '<div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear mb-0" style="height: 4px;">' +
                '<div class="v-progress-linear__background primary" style="height: 4px; opacity: 0.3; width: 100%;"></div>' +
                '<div class="v-progress-linear__bar">' +
                '<div id="toast-progress-bar-' + fileItem.name + '-determinate" class="v-progress-linear__bar__determinate accent" style="width: ' + progress.loaded + '%;"></div>' +
                '<div id="toast-progress-bar-' + fileItem.name + '-indeterminate" style="display: none" class="v-progress-linear__bar__indeterminate v-progress-linear__bar__indeterminate--active"><div class="v-progress-linear__bar__indeterminate long primary"></div><div class="v-progress-linear__bar__indeterminate short primary"></div></div>' +
                '<div id="toast-progress-bar-' + fileItem.name + '-success" style="display: none" class="v-progress-linear__bar__determinate success" style="width: ' + progress.loaded + '%;"></div>' +
                '</div>' +
                '</div>',
                {
                  id: 'toast-' + fileItem.name,
                  timeout: 0,
                  closeOnClick: true,
                  pauseOnHover: false,
                }
              )
            } else {
              const determinateBar = document.getElementById('toast-progress-bar-' + fileItem.name + '-determinate')
              const valueSpan = document.getElementById('toast-progress-value-' + fileItem.name)
              if (determinateBar) {
                determinateBar.style.width = progress.loaded + '%'
              }
              if (valueSpan) {
                valueSpan.innerText = String(progress.loaded)
              }
              if (progress.loaded === 100) {
                this.$snotify.remove('toast-' + fileItem.name)
              }
            }
          },

          success: (fileItem: CustomFile, response: any) => {
            this.$snotify.html(
              '<div class="fit"><span class="text-truncate block">' + fileItem.name + '</span></div>' +
              '<div class="caption fit"><span id="toast-progress-text-' + fileItem.name + '" class="text-truncate block">Файл загружен на <span id="toast-progress-value-' + fileItem.name + '"></span>100%</span></div>' +
              '<div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear mb-0" style="height: 4px;">' +
              '<div class="v-progress-linear__background green" style="height: 4px; opacity: 1; width: 100%;"></div>' +
              '<div class="v-progress-linear__bar">' +
              '<div id="toast-progress-bar-' + fileItem.name + '-success" style="display: none" class="v-progress-linear__bar__determinate success" style="width: 100%;"></div>' +
              '</div>' +
              '</div>',
              {
                id: 'toast-success' + fileItem.name,
                timeout: 3000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
              }
            )
            setTimeout(() => this.$snotify.remove('toast-' + fileItem.name), 0)
            setTimeout(() => this.$snotify.remove('toast-success' + fileItem.name), 2000)
          },

          warning: (fileItem: CustomFile, message: string) => {
            console.log('upload fail', fileItem, message)
          },

          error: (fileItem: CustomFile, message: string) => {
            console.log('upload fail', fileItem, message)
            this.$snotify.error('Внимание! Файл ' + fileItem.name + ' НЕ загружен!', {
              timeout: 3000,
              showProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
            })
          },
        }
        mFiles.push(item)
      })

      return mFiles
    },

    async onFileAdd(e: any, type: string): Promise<void> {
      console.log(this.$options.name, 'onFileAdd', 'e', e.target.files)
      console.log(this.$options.name, 'onFileAdd', 'type', type)

      if (!e.target.files?.length) return

      this.clear = true
      this.$nextTick(() => {
        this.clear = false
      })

      const uploadMethod = (files: CustomFile[]) => {
        if (type === 'cmdb') {
          files.forEach(file => this.fileUpload(file))
        }
        if (type === 'stream') {
          files.forEach(file => this.fileStreamUpload(file))
        }
      }

      const files = Array.from(e.target.files) as CustomFile[]

      for (const file of files) {
        const hash = await this.generateFileHash(file)
        if (!this.current.files.find(item => item.data?.hash === hash)) {
          file.data = {
            hash: hash,
            description: '',
          }
          this.current.files.push(file)
        } else {
          this.$snotify.warning(`Внимание! Файл ${file.name} уже загружен!`, {
            timeout: 3000,
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          })
        }
      }

      const mappedFiles = await this.mapFiles()
      uploadMethod(mappedFiles)
    },

    async fileStreamUpload(payload: CustomFile): Promise<any> {
      console.log(this.$options.name, 'fileStreamUpload', 'payload', payload)
      try {
        const result = await this.$store.dispatch('file/upload/execute', {
          filetype: payload.type,
          $id: null,
          list: [payload],
          vm: this,
          method: 'arrayBuffer',
          params: { type: 'backup' }
        })
        console.log(this.$options.name, 'fileStreamUpload', 'result', result)
        this.loadDumps()
        return result
      } catch (error) {
        console.error('CATCH', this.$options.name, 'fileStreamUpload', error)
        throw error
      }
    },

    async fileUpload(payload: CustomFile): Promise<Response> {
      console.log(this.$options.name, 'fileUpload', 'payload', payload)
      const host = $_localhost ? 'http://192.168.2.69' : window.location.origin
      const fileName = payload.name || ''

      try {
        const formData = new FormData()
        formData.append('parentId', this.cmdbBackupFilesParentId)
        formData.append('type', 'file')
        formData.append('files', payload)

        const response = await fetch(host + '/e-cluster/filemanager/files', {
          method: 'POST',
          body: formData,
        })

        if (response.ok) {
          this.$dialog.notify.success(`Файл "${fileName}" успешно загружен`, { timeout: 5000 })
          this.loadDumps()
          return response
        } else {
          this.$dialog.notify.error(`Ошибка загрузки файла "${fileName}": ${response.statusText}`, { timeout: 5000 })
          throw new Error(`HTTP error ${response.status}: ${response.statusText}`)
        }
      } catch (error) {
        console.error('CATCH', this.$options.name, 'fileUpload', error)
        throw error
      }
    },

    async generateFileHash(file: CustomFile): Promise<string> {
      try {
        const fileInfo = `${file.name}${file.lastModified}${file.size}${file.type}`
        const encoder = new TextEncoder()
        const data = encoder.encode(fileInfo)
        const hash = await crypto.subtle.digest('SHA-256', data)
        return Array.from(new Uint8Array(hash))
          .map(b => b.toString(16).padStart(2, '0'))
          .join('')
      } catch (error: any) {
        throw new Error(`Ошибка генерации хеша: ${error.message}`)
      }
    },

    async restoreCopy(val: string): Promise<void> {
      console.log(this.$options.name, 'restoreCopy', 'val', val)
      try {
        if (!val) return
        this.setLoader('restoreCopy', true)

        if (val === 'cmdb') {
          await this.$bridge.customQuery('scripter', 'exec', { method: 'cluster.genPGRestore', noMeta: true, data: { database: 'cmdb', fileName: this.selectedCMDBDump?.name } }, 'post')
        }
        if (val === 'stream') {
          await this.$bridge.customQuery('core', 'monitoring/restoreBackUp', { backupName: this.selectedStreamDump?.name }, 'get')
        }

        this.setLoader('restoreCopy', false)
        this.$dialog.notify.success('Резервная копия восстановлена', { timeout: 5000 })

        if (val === 'cmdb') {
          this.$dialog.notify.success('Система будет перезагружена, и будет доступна через несколько минут.', { timeout: 5000 })
          await this.$bridge.customQuery('scripter', 'exec', { method: 'cluster.rebootCmdb', noMeta: true }, 'post')
          await this.$bridge.logout()
          this.$router.push({ name: 'login' })
        }
      } catch (error) {
        console.error(this.$options.name, 'restoreCopy smth wrong', error)
        this.setLoader('restoreCopy', false)
      }
    },

    async createCopy(val: string): Promise<void> {
      console.log(this.$options.name, 'createCopy', 'START', val)
      try {
        if (!val) return
        this.setLoader('createCopy', true)

        if (val === 'cmdb') {
          await this.$bridge.customQuery('scripter', 'exec', { method: 'cluster.genPGBackUp', noMeta: true, data: { database: 'cmdb' } }, 'post')
        }
        if (val === 'stream') {
          await this.$bridge.customQuery('core', 'monitoring/createBackUp', {}, 'get')
        }

        await this.setup()
        this.setLoader('createCopy', false)
        this.$dialog.notify.success('Резервная копия создана', { timeout: 5000 })
      } catch (error) {
        console.error(this.$options.name, 'createCopy smth wrong', error)
        this.setLoader('createCopy', false)
      }
    },

    async downloadCopy(val: string): Promise<void> {
      console.log(this.$options.name, 'downloadCopy', 'val', val)
      try {
        if (!val) return
        this.setLoader('downloadCopy', true)

        if (val === 'cmdb' && this.selectedCMDBDump) {
          const r = await this.$bridge.customQuery('scripter', 'filemanager/download', { items: this.selectedCMDBDump.id }, 'get')
          this.$store.dispatch('file/download/save', {
            content: r,
            filename: this.selectedCMDBDump.name
          })
        }
        if (val === 'stream' && this.selectedStreamDump) {
          this.$store.dispatch('file/download/streamSave', {
            filename: this.selectedStreamDump.backUpName,
            vm: this
          })
        }

        this.setLoader('downloadCopy', false)
      } catch (error) {
        console.error(this.$options.name, 'downloadCopy smth wrong', error)
        this.setLoader('downloadCopy', false)
      }
    },

    async submit(): Promise<void> {
      console.log(this.$options.name, 'submit', 'START')
      try {
        if (!this.data && !this.sdata) return
        this.setLoader('submit', true)

        if (this.data) {
          const obj = this.data._cmdb_ ? this.data : new CCMDBObject({ ...this.data })
          await obj.update(this.model.obj)
        }

        if (this.sdata) {
          const sobj = this.sdata._cmdb_ ? this.sdata : new CCMDBObject({ ...this.sdata })
          await sobj.update(this.smodel.obj)
        }

        if (this.streamData) {
          console.log(this.$options.name, 'submit', 'this.streamData', this.streamData)
          const nodes = Object.keys(this.streamData).map(key => ({
            name: key,
            type: 'config',
            data: this.streamData![key]
          }))

          const requests = nodes.map(node =>
            this.$bridge.customQuery('core', 'net-storage/createInPath', { path: 'tree:/config/service', node }, 'post')
          )
          await Promise.all(requests)
        }

        this.setLoader('submit', false)
        this.$dialog.notify.success('Параметры успешно обновлены', { timeout: 5000 })
        await this.$bridge.customQuery('scripter', 'exec', { method: 'cluster.rebootCluster', noMeta: true }, 'post')
        this.edit = false
        await this.setup()
      } catch (error) {
        console.error(this.$options.name, 'submit smth wrong', error)
        this.setLoader('submit', false)
      }
    },
  },
})
</script>

<style lang="stylus" scoped>

    .button-file-upload

        position: relative
        box-sizing: border-box

        &_extension

            &_blank

                padding-left: 0;
                border-color: transparent

            &_new

                padding-left: 0;
                border-color: transparent

        &__area

            display: flex
            justify-content: center

            width: 80px
            height: 80px

            border-radius: 50%
            border: 1px solid alpha(#000, .4)

        &__control

            position: relative
            overflow: hidden
            z-index: 2

            cursor: pointer

            &.fiv-icon-blank

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

            &.fiv-icon-new

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

        &__overlay

            position: absolute

            top: 0
            right: 0
            bottom: 0
            left: 0

            margin-right: -8px

            width: 100%
            /* height */

            background: alpha(#fff, .9)

            opacity: 0
            transition: opacity .4s

            &:hover

                opacity: 1

        &__delete

            cursor: pointer

            margin-right: -16px
            margin-top: -16px

            opacity: .5
            transition: opacity .4s

            &:hover

                opacity: 1

        &__input

            display: block
            position: absolute

            top: 0
            right: 0

            width: 100%
            height: 100%
            /* min-width: 100%
            min-height: 100% */

            text-align: right

            opacity: 0
            outline: none
            cursor: inherit

        &__name

            display: block /* Fallback for non-webkit */
            max-height: calc(20px * 2) /* Fallback for non-webkit */
            min-height: calc(20px * 2) /* Fallback for non-webkit */
            margin: 0 auto
            font-size: 12px
            line-height: 16px
            -webkit-line-clamp: 3
            -webkit-box-orient: vertical
            overflow: hidden
            text-overflow: ellipsis
            word-break: break-all
            text-align: center;


</style>
